export default {
  data () {
    return {
      required: [
        v => !!v || ''
      ]
    }
  }
}
